import {
    CHECK_IF_USER_LOCKED_PATH,
    GET_PATIENT_DATA_PATH,
    MAX_SEND_OTP_ERROR,
    MAX_VERIFY_OTP_ERROR,
    SEND_OTP_PATH,
    SERVER_URL
} from "../consts/consts";
import FingerprintJS from '@fingerprintjs/fingerprintjs';


async function getClientUniqueIdentifier() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
}

export const verifyPatientAndSendOtp = async (id: string, phone: string, sessionId: string, translation: any, language: string) => {
    try {
        const uniqueIdentifier = await getClientUniqueIdentifier();
        const response = await fetch(`${SERVER_URL}${SEND_OTP_PATH}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "id": id,
                "phone": phone,
                "session_id": sessionId,
                "website_language": language,
                "identifier": uniqueIdentifier
            })
        });

        if (!response.ok) {
            if (response.status === 403) {
                throw new Error(MAX_SEND_OTP_ERROR)
            }
            if (response.status === 401) {
                throw new Error(translation.unauthorized_sf_error);
            }
            throw new Error(translation.general_sever_error);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const validateCode = async (id: string, phone: string, otp: string, sessionId: string, translation: any, language: string) => {
    try {
        const uniqueIdentifier = await getClientUniqueIdentifier();

        const response = await fetch(`${SERVER_URL}${GET_PATIENT_DATA_PATH}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "id": id,
                "phone": phone,
                "otp": otp,
                "session_id": sessionId,
                "website_language": language,
                "identifier": uniqueIdentifier
            })
        });

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error(translation.invalid_code_message);
            } else if (response.status === 403) {
                throw new Error(MAX_VERIFY_OTP_ERROR)
            } else {
                throw new Error(translation.general_sever_error);
            }
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};


export const checkLockStatus = async (translation: any) => {
    try {
        const uniqueIdentifier = await getClientUniqueIdentifier();
        const response = await fetch(`${SERVER_URL}${CHECK_IF_USER_LOCKED_PATH}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "identifier": uniqueIdentifier
            })
        });

        if (!response.ok) {
            throw new Error(translation.general_sever_error);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};
